import React, { useCallback, useContext, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { save, putToDbIndex } from "../../lib/comm";
import {
  MainContext,
  STATUS_ONLINE,
  UIContext,
  UpdateContext,
} from "../../main-context";
import Completed from "../helpers/Lists/Completed";
import Incompleted from "../helpers/Lists/Incompleted";
import { unique } from "../../lib/filter";
import {
  getInspectionUrl,
  INSPECTION_URL_TYPE_ROUTE,
} from "../../lib/calculation";

export default function InspectionList({
  inspectionAirlines,
  inspectionFilter,
  showType,
  type,
  setSelectedAirline,
  offline_css,
  existsInDatabase,
}) {
  const history = useHistory();
  const main_context = useContext(MainContext);
  const update_context = useContext(UpdateContext);
  const ui_context = useContext(UIContext);
  const serviceNotUsed = useCallback(
    (equipment_id, date_if_not_now, type, operationId) => {
      let url = "/api/inspections/" + equipment_id + "/" + operationId + "/nu";
      if (date_if_not_now) {
        url +=
          "?date=" +
          encodeURIComponent(date_if_not_now) +
          "&inspection_maintainer=true&type=" +
          type;
      } else {
        url += "?type=" + type;
      }

      return save(
        url,
        {},
        main_context.status.id,
        update_context,
        history,
        null,
        10
      );
    },
    [history, main_context.status.id, update_context]
  );

  const title = useCallback((inspection) => {
    return `${inspection.title} (${inspection.done}/${inspection.count}) ${inspection.niceType}`;
  }, []);

  const notUsed = useCallback(
    async (inspection, if_not_now_date) => {
      update_context.update_main_context((prev) => ({
        ...prev,
        inspections: {
          ...prev.inspections,
          [type]: prev.inspections[type].map((elem) =>
            elem.id !== inspection.id
              ? elem
              : {
                  ...elem,
                  nuloading: true,
                  offline_complete: true,
                }
          ),
        },
      }));

      try {
        await serviceNotUsed(
          inspection.id,
          if_not_now_date,
          inspection.type,
          inspection.operationId
        );
        update_context.update_main_context((prev) => {
          const new_main_context = {
            ...prev,
            inspections: {
              ...prev.inspections,
              [type]: prev.inspections[type].map((elem) =>
                elem.id !== inspection.id
                  ? elem
                  : {
                      ...elem,
                      closed: true,
                      nuloading: false,
                      status: 5,
                      done: 0,
                      offline_complete:
                        ui_context.online_status !== STATUS_ONLINE,
                    }
              ),
            },
          };

          putToDbIndex(
            "/api/inspections/" +
              (type === "daily" || type === "weekly" || type === "fso"
                ? type
                : "maintenance"),
            main_context.status.id,
            new_main_context.inspections
          );

          return new_main_context;
        });
      } catch (error) {
        update_context.update_ui_context((prev) => ({
          ...prev,
          error: error,
        }));
      }
    },
    [
      main_context.status.id,
      serviceNotUsed,
      type,
      ui_context.online_status,
      update_context,
    ]
  );

  const startInspection = useCallback(
    (inspection) => {
      history.push(
        getInspectionUrl(
          INSPECTION_URL_TYPE_ROUTE,
          inspection,
          update_context.settings.subfolder
        )
      );
    },
    [history, update_context.settings.subfolder]
  );

  const checkDueThisPeriod = useCallback(
    (dueThisPeriod, dueDate, inspectionType) => {
      if (!dueThisPeriod) {
        var dateObj = new Date(dueDate * 1000);
        if (!["monthly", "semi-annual", "quarterly"].includes(inspectionType)) {
          window.alert(
            "This inspection is not due until " +
              (dateObj.getMonth() + 1) +
              "/" +
              dateObj.getFullYear()
          );
          return false;
        }
      }
      return true;
    },
    []
  );

  const countOps = useMemo(() => {
    return main_context.inspections && main_context.inspections[type]
      ? unique(main_context.inspections[type], (elem) => elem.operationId)
          .length
      : 0;
  }, [main_context.inspections, type]);

  return (
    <>
      {inspectionAirlines && (
        <div className="row">
          <div className="col-xs-offset-4 col-xs-4 text-left">
            <select
              onChange={(ev) => setSelectedAirline(ev.target.value)}
              className="form-control"
            >
              <option value="" selected>
                Airline Filter
              </option>
              {Object.keys(inspectionAirlines).map((x) => (
                <option value={x} key={x}>
                  {inspectionAirlines[x]}
                </option>
              ))}
            </select>
            <br />
          </div>
        </div>
      )}
      <div
        className="row"
        style={{
          width: "100%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          maxWidth: "600px",
        }}
      >
        <div
          style={{
            flexBasis: "49%",
            minWidth: "100px",
            flexGrow: 0,
            flexShrink: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <>
            {!!inspectionFilter("complete", type).length && (
              <div
                className={
                  "col-completed " +
                  (type === "daily" || type === "weekly"
                    ? offline_css["daily-col-list"]
                    : "")
                }
              >
                <Completed
                  checkDueThisPeriod={checkDueThisPeriod}
                  startInspection={startInspection}
                  inspectionFilter={inspectionFilter}
                  type={type}
                  title={title}
                  countOps={countOps}
                  existsInDatabase={existsInDatabase}
                ></Completed>
              </div>
            )}
            {!!inspectionFilter("offline_complete", type).length && (
              <div
                className={
                  "col-offline-completed " + offline_css["daily-col-list"]
                }
              >
                <ul className="list-unstyled" style={{ width: "100%" }}>
                  {inspectionFilter("offline_complete", type).map(
                    (inspection) => (
                      <li key={title(inspection) + "_" + inspection.id}>
                        <div
                          title={title(inspection)}
                          onClick={() =>
                            !inspection.oos && startInspection(inspection)
                          }
                          className="btn btn-warning btn-inspection"
                          style={{
                            float: "right",
                            cursor: inspection.oos ? "text" : "pointer",
                            whiteSpace: "normal",
                            position: "relative",
                            backgroundColor: !inspection.oos ? null : "gray",
                            border: !inspection.oos ? "" : "1px solid gray",
                          }}
                        >
                          {countOps > 1 && (
                            <sup
                              style={{
                                position: "absolute",
                                top: "9px",
                                left: "3px",
                              }}
                            >
                              {inspection.operationShortName}
                            </sup>
                          )}
                          <span>{inspection.title}</span>
                          {inspection.oos && inspection.status !== 5 && (
                            <span>
                              (<strong>OOS</strong>)
                            </span>
                          )}
                          {!inspection.oos && inspection.status !== 5 && (
                            <span>
                              (<span>{inspection.count}</span>/
                              <span>{inspection.count}</span>)
                            </span>
                          )}
                          {inspection.status === 5 &&
                            inspection.offline_number &&
                            inspection.offline_number !== 0 && (
                              <span>
                                (<span>{inspection.offline_number}</span>/
                                <span>{inspection.count}</span>)
                              </span>
                            )}
                          {inspection.status === 5 &&
                            !inspection.offline_number && (
                              <span>
                                (<strong>NU</strong>)
                              </span>
                            )}
                        </div>
                      </li>
                    )
                  )}
                </ul>
              </div>
            )}
          </>
        </div>
        <div
          style={{
            flexBasis: "49%",
            minWidth: "100px",
            flexGrow: 0,
            flexShrink: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {!!inspectionFilter("incomplete", type).length && (
            <div
              className={
                "col-uncompleted " +
                (type === "daily" || type === "weekly"
                  ? offline_css["daily-col-list"]
                  : "")
              }
              style={{
                minWidth: "100px",
                flexGrow: 0,
                flexShrink: 0,
                display: "flex",
                marginLeft: "2%",
              }}
            >
              <Incompleted
                startInspection={startInspection}
                inspectionFilter={inspectionFilter}
                notUsed={notUsed}
                showType={showType}
                type={type}
                title={title}
                countOps={countOps}
                existsInDatabase={existsInDatabase}
              ></Incompleted>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
